import React, { useState } from 'react';
import ChangePasswordModal from '../../components/ChangePasswordModal';
import SystemCostsTab from './SystemCostsTab';

/**
 * Admin settings hub.
 *
 * Two tabs: "אבטחה" (password / account access) and "עלויות מערכת"
 * (the system-costs dashboard). New settings areas land as further
 * tabs here.
 */
function SettingsPage() {
  const [activeTab, setActiveTab] = useState('security');

  const tabs = [
    { key: 'security', label: 'אבטחה' },
    { key: 'costs', label: 'עלויות מערכת' },
  ];

  return (
    <>
      <h2 style={{ fontSize: '1.1rem', fontWeight: 600, marginBottom: '1rem' }}>
        הגדרות
      </h2>

      <div style={{
        display: 'flex',
        gap: '0.25rem',
        borderBottom: '1px solid #e5e7eb',
        marginBottom: '1.4rem',
      }}>
        {tabs.map(t => (
          <button
            key={t.key}
            type="button"
            onClick={() => setActiveTab(t.key)}
            style={{
              border: 'none',
              background: 'none',
              cursor: 'pointer',
              padding: '0.6rem 1rem',
              fontFamily: 'Heebo, sans-serif',
              fontSize: '0.9rem',
              fontWeight: activeTab === t.key ? 600 : 500,
              color: activeTab === t.key ? '#1a1a2e' : '#9ca3af',
              borderBottom: `2px solid ${activeTab === t.key ? '#3b82f6' : 'transparent'}`,
              marginBottom: '-1px',
            }}
          >
            {t.label}
          </button>
        ))}
      </div>

      {activeTab === 'security' && <SecurityTab />}
      {activeTab === 'costs' && <SystemCostsTab />}
    </>
  );
}


function SecurityTab() {
  const [showChangePassword, setShowChangePassword] = useState(false);

  return (
    <>
      <SettingsCard title="אבטחה" subtitle="ניהול הסיסמה והגישה לחשבון.">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => setShowChangePassword(true)}
        >
          שינוי סיסמה
        </button>
      </SettingsCard>

      {showChangePassword && (
        <ChangePasswordModal onClose={() => setShowChangePassword(false)} />
      )}
    </>
  );
}


function SettingsCard({ title, subtitle, children }) {
  return (
    <div style={{
      background: '#fff',
      border: '1px solid #e5e7eb',
      borderRadius: '8px',
      padding: '1.1rem 1.25rem',
      marginBottom: '1rem',
      maxWidth: '640px',
    }}>
      <h3 style={{ margin: 0, fontSize: '1rem', fontWeight: 600 }}>{title}</h3>
      {subtitle && (
        <p style={{ color: '#6b7280', fontSize: '0.8rem', margin: '0.3rem 0 0' }}>
          {subtitle}
        </p>
      )}
      <div style={{ marginTop: '0.85rem' }}>
        {children}
      </div>
    </div>
  );
}

export default SettingsPage;
